import React, {Fragment} from 'react';
import styles from './designer.module.css';
import '@mescius/activereportsnet-designer/dist/web-designer.css';

type DesignerProps = {
  report: string | undefined;
  isDashboard: boolean;
  onPreview: (reportId: string, theme: any) => void;
};

type DesignerState = {
  designer: any;
}

export default class Designer extends React.Component<DesignerProps, DesignerState> {
  constructor(props: DesignerProps) {
    super(props);

    this.state = {designer: null};
  }

  componentDidMount() {
    if (this.state.designer == null) {
      GrapeCity.ActiveReports.Designer.create('#designerContainer', {
        appBar: {saveButton: {visible: false}, saveAsButton: {visible: false}, parametersTab: {visible: false}},
        server: {url: 'api'},
        data: {dataSets: {canModify: false}, dataSources: {canModify: false}},
        documents: {
          fileView: {visible: false}
        },
        storeUnsavedReport: false,
        fonts: ['Arial', 'Courier New'],
        themes: {
        	initialTheme: 'activeReports',
        	themeSelector: {
        		enabled: false,
        		availableThemes: ['activeReports']
        	}
        },
        preview: {
          openViewer: (options: any) => {
            this.props.onPreview(options.documentInfo.id, options.theme);
          }
        }
      }).then((designerApi: any) => {
        this.setState({designer: designerApi})
        designerApi.documents.openById(this.props.report, {platform: 'rdlx', type: this.props.isDashboard ? 'dashboard' : 'report', subType: 'cpl'})
      });
    }
  }

  componentWillUnmount() {
    if (this.state.designer) {
      GrapeCity.ActiveReports.Designer.destroy('#designerContainer');
    }
  }

  render() {
    return (
      <Fragment>
        <div id="designerContainer" className={styles.root}/>
      </Fragment>
    );
  }
}
